import React, { useState } from 'react';
import { connect } from 'react-redux';
import styles from './increaseInvegaLoanSumModal.module.scss';
import { Button, WithSpinner, InputWithTextInline } from '../../components';
import { actions } from '../../state/actions';
import { config } from './../../api/config';
import { Api } from './../../api/api';
import swal from 'sweetalert';

const InvegaLoanSumModal = ({ open, loading, dispatch, requestId }) => {
  const [sum, setSum] = useState(null);
  const [notValid, setNotvalid] = useState(false);

  const cancel = () => {
    const open = {
      modalName: 'increaseInvegaLoanSumModal',
      visible: false,
    };
    dispatch(actions.modals.setModalVisibleFlagAction(open));
  };

  const setValue = (e) => {
    setSum(e.target.value);
  };

  const isSumValid = () => {
    if (!sum) {
      return 'Neįvesta suma. Formatas 0.00 EUR';
    }
    var ex = /^\d*\.?\d{0,2}$/;
    if (ex.test(sum) === false) {
      return 'Turi būti įvesti skaičiai (formatas 0.00)';
    }
    return null;
  };

  const saveSum = () => {
    setNotvalid(true);
    if (isSumValid() == null) {
      fetch(Api.API_BASE_URL + config.API_ENDPOINTS.increaseInvegaLoanSum, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          RequestId: requestId,
          Sum: sum,
        }),
      })
        .then((res) => {
          if (res.ok === true) {
            swal({
              title: 'Paskolos suma sėkmingai padidinta',
              icon: 'success',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn btn-pink',
                  closeModal: true,
                },
              },
            });
          } else if (res.status === 403) {
            swal({
              title: `Šiam veiksmui atlikti neturite reikiamų teisių. Kreipkitės į sistemos administratorių`,
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn swal-ok-btn',
                  closeModal: true,
                },
              },
            });
          } else {
            res.json().then((err) => {
              console.log(err);
              swal({
                title: err.ErrorDescription,
                icon: 'error',
                buttons: {
                  confirm: {
                    text: 'Gerai',
                    value: true,
                    visible: true,
                    className: 'btn swal-ok-btn',
                    closeModal: true,
                  },
                },
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        //.then((response) => response.json())
        .finally(() => {
          dispatch(actions.backoffice.getRequestAction(requestId));
          cancel();
        });
    }
  };

  return (
    open && (
      <div className={styles.container}>
        <div
          className={styles.modal}
          id="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__title"
          aria-describedby="modal__desc"
        >
          <WithSpinner loading={loading}>
            <div className="modal-title">
              <InputWithTextInline
                type="text"
                value={sum}
                inOneLine={false}
                placeholder="Įveskite padidintą paskolos sumą"
                onChange={(e) => setValue(e)}
              ></InputWithTextInline>
            </div>
            {notValid && <p className="errorsBlockText">{isSumValid()}</p>}

            <div className={styles.btnContainer}>
              <div>
                <Button type="standart" onClick={() => saveSum()}>
                  Tvirtinti
                </Button>
                <Button type="cancel" onClick={() => cancel()}>
                  Atšaukti
                </Button>
              </div>
            </div>
          </WithSpinner>
        </div>
      </div>
    )
  );
};

const mapStateToProps = (state) => ({
  loading: state.dashboardState.isOnSync,
});

export default connect(mapStateToProps)(InvegaLoanSumModal);
